module.exports = __webpack_public_path__ + "img/confirm.f335aed3.png";